import { api } from "api/apiService";

/**
 * Завантажує список доступних кастомних міток.
 * @returns {Promise<object>} Проміс, що повертає об'єкт зі списком міток.
 */
export const fetchCustomTags = () => api.get("/custom-tags");

/**
 * Прив'язує мітку до товару
 * @param {number} tagId - ідентифікатор мітки
 * @param {string} article - артикул товару
 */
export const assignCustomTag = (tagId, article) => {
  const url = `/custom-tags/${tagId}/articles/${encodeURIComponent(article)}`;
  return api.post(url);
};

/**
 * Відв'язує мітку від товару
 * @param {number} tagId - ідентифікатор мітки
 * @param {string} article - артикул товару
 */
export const removeCustomTag = (tagId, article) => {
  const url = `/custom-tags/${tagId}/articles/${encodeURIComponent(article)}`;
  return api.delete(url);
};
